import { request, Row, Rows } from './request';
import { Exhibition } from './models/exhibitions/Exhibition';
import {
  ExhibitionDetail,
  ExhibitionDetailViewModel,
} from './models/exhibitions/ExhibitionDetail';
import { Product } from './models/products/res/Product';
import { ProductOption } from './models/products/res/ProductOption';

export const fetchExhibitions = async (
  partnerCode: string,
  isTempData?: boolean,
) => {
  const url = '/app/exhibitions';
  try {
    const { data } = await request<Rows<Exhibition>>({
      method: 'get',
      url,
      queryParams: {
        partnerCode,
        isTempData,
      },
    });
    const { rows } = data;
    return rows;
  } catch (e) {
    return [];
  }
};

export const fetchExhibitionDetail = async (
  partnerCode: string,
  exhibitionId: string | number,
  isTempData?: boolean,
): Promise<ExhibitionDetailViewModel | null> => {
  const url = `/app/exhibitions/${exhibitionId}`;
  try {
    const { data } = await request<Row<ExhibitionDetail>>({
      method: 'get',
      url,
      queryParams: {
        partnerCode,
        isTempData,
      },
    });
    const { row } = data;

    return {
      ...row,
      events: row.events.map((rawEvent) => {
        return {
          ...rawEvent,
          products: rawEvent.products.map((rawProduct) => {
            const product: Product = {
              id: rawProduct.id,
              productName: rawProduct.productName,
              productIntroduction: rawProduct.productIntroduction,
              maxProductOptionPrice: rawProduct.productPrice,
              minProductOptionPrice: rawProduct.productPrice,
              productOptions: rawProduct.productOptions.map(
                (rawProductOption) => {
                  const productOption: ProductOption = {
                    id: rawProductOption.id,
                    productOptionName: rawProductOption.productOptionName,
                    productOptionTax: 0,
                    productOptionSoldOut: false,
                    productOptionPeriod: null,
                    productOptionBadges: [],
                    categoryNames: '',
                    totalTicket: null,
                    productOptionType: 'DEFAULT',
                    productOptionDiscountTax: 0,
                    productOptionTotalDiscountPrice:
                      rawProductOption.productOptionDiscountPrice || null,
                    productOptionTotalPrice:
                      rawProductOption.productOptionPrice,
                  };
                  return productOption;
                },
              ),
            };
            return product;
          }),
        };
      }),
      categories: row.categories.map((rawCategory) => {
        return {
          ...rawCategory,
          products: rawCategory.products.map((rawProduct) => {
            const product: Product = {
              id: rawProduct.id,
              productName: rawProduct.productName,
              productIntroduction: rawProduct.productIntroduction,
              maxProductOptionPrice: rawProduct.productPrice,
              minProductOptionPrice: rawProduct.productPrice,
              productOptions: rawProduct.productOptions.map(
                (rawProductOption) => {
                  const productOption: ProductOption = {
                    id: rawProductOption.id,
                    productOptionName: rawProductOption.productOptionName,
                    productOptionTax: 0,
                    productOptionSoldOut: false,
                    productOptionPeriod: null,
                    productOptionBadges: [],
                    categoryNames: '',
                    totalTicket: null,
                    productOptionType: 'DEFAULT',
                    productOptionDiscountTax: 0,
                    productOptionTotalDiscountPrice:
                      rawProductOption.productOptionDiscountPrice || null,
                    productOptionTotalPrice:
                      rawProductOption.productOptionPrice,
                  };
                  return productOption;
                },
              ),
            };
            return product;
          }),
        };
      }),
    };
  } catch (e) {
    return null;
  }
};
